import { render, staticRenderFns } from "./DialogEditProfile.vue?vue&type=template&id=5f78ade4"
import script from "./DialogEditProfile.vue?vue&type=script&lang=js"
export * from "./DialogEditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports